export default "__VITE_ASSET__7xJLr_7N__"